import styled from 'styled-components';

export const SliderContainer = styled.div`
  background: #fff;
  height: 100px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;

  @media (max-width: 768px) {
    padding: 100px 0;
  }

  .slick-slide {
    height: 200px;
    text-align: center;
  }

  .slides {
    position: relative;
  }
`;

export const ClientWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(100%);
  height: 100px;
`;

export const ClientImage = styled.img`
  max-width: 150px;
  height: 80px;
`;
